/* BarBank 2.0 email popup — replaces Klaviyo form XEEGBL.
 *
 * Behavior (mirrors XEEGBL's triggers):
 *   - exit intent: desktop = cursor leaves through the top (any time, except 3s after the age gate closes);
 *     mobile = quick upward scroll after reading, or the 2nd page view of the session
 *   - never for profiles Klaviyo already knows (klaviyo.isIdentified / __kla_id cookie) or logged-in customers
 *   - never again after a successful signup; 1-day cooldown after a close
 *   - never while the age gate is up
 *   - QA: ?bbpop=1 forces it open (ignores rules, still subscribes for real)
 *
 * Signup: Klaviyo Client Subscriptions API → list R4H9pm → [PDM] Welcome Series sends the $10 code.
 * Analytics: GA4 events (bb_popup_*), Klaviyo identify + "BarBank Popup Signup" event, and a per-browser
 *            session log in localStorage for debugging.
 */
(function () {
  'use strict';
  var tpl = document.getElementById('bbpop-tpl');
  if (!tpl) return;

  var KEY_DONE = 'bb_pop_subscribed';       // set on success → never show again
  var KEY_CLOSED = 'bb_pop_closed_at';      // ms timestamp of last close → 1-day cooldown
  var COOLDOWN_MS = 24 * 60 * 60 * 1000;
  var AGE_GRACE_MS = 3000;                  // ignore exit intent for 3s after the age gate closes (no other dwell minimum)
  var REVISION = '2025-10-15';
  var force = /[?&]bbpop=1\b/.test(location.search);
  var ageClosedAt = 0;                      // set when the age gate finishes closing on this page view
  var shown = false, root, cfg, lastFocus;
  var loggedIn = /data-logged-in="1"/.test(tpl.innerHTML);

  function ls(k, v) {
    try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; }
  }

  /* ---------- analytics ---------- */
  function track(name, params) {
    params = Object.assign({ popup_id: 'bb_email_10off_v1', page_path: location.pathname }, params || {});
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
      else (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params));
    } catch (e) {}
    try {
      var log = JSON.parse(ls('bb_pop_log') || '[]'); log.push([Date.now(), name]); ls('bb_pop_log', JSON.stringify(log.slice(-20)));
    } catch (e) {}
  }

  /* ---------- eligibility ---------- */
  function cookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function klaviyoKnowsFromCookie() {
    var raw = cookie('__kla_id');
    if (!raw) return false;
    try { var d = JSON.parse(atob(raw)); return !!(d.$exchange_id || d.$email || d.$phone_number || d.$kla_id); } catch (e) { return false; }
  }
  function knownToKlaviyo() {
    if (klaviyoKnowsFromCookie()) return Promise.resolve(true);
    try {
      if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
        return Promise.race([
          Promise.resolve(window.klaviyo.isIdentified()).then(Boolean),
          new Promise(function (r) { setTimeout(function () { r(false); }, 1500); })
        ]).catch(function () { return false; });
      }
    } catch (e) {}
    return Promise.resolve(false);
  }
  // Old Klaviyo form XEEGBL: Klaviyo's onsite script records closes/submits in localStorage 'klaviyoOnsite'
  // under viewedForms.modal.disabledForms[formId]. Honor it so people who already used the old popup
  // aren't asked again (submitted → never; closed → same 24h cooldown).
  function legacyKlaviyo() {
    try {
      var d = JSON.parse(ls('klaviyoOnsite') || '{}');
      var f = d && d.viewedForms && d.viewedForms.modal && d.viewedForms.modal.disabledForms && d.viewedForms.modal.disabledForms.XEEGBL;
      if (!f) return '';
      var s = JSON.stringify(f);
      if (/success|submit/i.test(s)) return 'subscribed';
      var t = f.lastCloseTime || f.closeTime || 0;
      if (t && Date.now() - (t < 1e12 ? t * 1000 : t) < COOLDOWN_MS) return 'cooldown';
    } catch (e) {}
    return '';
  }
  function ruleBlocked() {
    if (ls(KEY_DONE)) return 'subscribed';
    var legacy = legacyKlaviyo(); if (legacy) return legacy;
    var c = parseInt(ls(KEY_CLOSED) || '0', 10);
    if (c && Date.now() - c < COOLDOWN_MS) return 'cooldown';
    return '';
  }
  function ageGateUp() {
    var h = document.documentElement.classList;
    return h.contains('bb-age-active') || h.contains('bb-age-exiting');
  }

  /* ---------- show / hide ---------- */
  function loadCss() {
    var s = document.querySelector('script[data-css][src*="bb-popup"]');
    if (!s || document.getElementById('bbpop-css')) return Promise.resolve();
    return new Promise(function (res) {
      var l = document.createElement('link'); l.id = 'bbpop-css'; l.rel = 'stylesheet'; l.href = s.getAttribute('data-css');
      l.onload = l.onerror = function () { res(); }; document.head.appendChild(l);
      setTimeout(res, 1500);
    });
  }

  function attempt(trigger) {
    if (shown) return;
    if (!force) {
      if (ageClosedAt && Date.now() - ageClosedAt < AGE_GRACE_MS) return;
      if (ruleBlocked() || ageGateUp()) return;
      if (loggedIn) return;
      if (document.querySelector('[data-panel].open, .m6pn.inview, #root.m2-active')) return; // a theme drawer is open
    }
    shown = true;
    (force ? Promise.resolve(false) : knownToKlaviyo()).then(function (known) {
      if (known) { track('bb_popup_suppressed', { reason: 'known_profile' }); return; }
      return loadCss().then(function () { open(trigger); });
    });
  }

  function open(trigger) {
    document.body.appendChild(tpl.content.cloneNode(true));
    root = document.getElementById('bbpop');
    cfg = root.dataset;
    lastFocus = document.activeElement;
    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-bbpop-close]');
      if (c) close(c.getAttribute('data-bbpop-close'));
    });
    root.querySelector('form').addEventListener('submit', submit);
    document.addEventListener('keydown', onKey);
    lockScroll();
    document.documentElement.classList.add('bbpop-open');
    requestAnimationFrame(function () { root.classList.add('is-in'); });
    setTimeout(function () { var i = root.querySelector('#bbpop-email'); if (i && window.matchMedia('(min-width: 750px)').matches) i.focus(); }, 250);
    track('bb_popup_view', { trigger: trigger });
  }

  // Block background scrolling without moving the page (no body freeze -> nothing to restore -> no jump on close).
  // iOS ignores overflow:hidden, so cancel the scroll gestures themselves unless they're scrolling inside the card.
  function blockScroll(e) {
    var card = root && root.querySelector('.bbpop__card');
    if (card && card.contains(e.target) && card.scrollHeight > card.clientHeight + 1) {
      var atTop = card.scrollTop <= 0, atBottom = card.scrollTop + card.clientHeight >= card.scrollHeight - 1;
      if (e.type === 'wheel') {
        var dy = e.deltaY || 0;
        if (!((dy < 0 && atTop) || (dy > 0 && atBottom))) return; // let the card scroll
      } else if (!(atTop && atBottom)) return;
    }
    if (e.cancelable) e.preventDefault();
  }
  function lockScroll() {
    document.addEventListener('touchmove', blockScroll, { passive: false });
    document.addEventListener('wheel', blockScroll, { passive: false });
  }
  function unlockScroll() {
    document.removeEventListener('touchmove', blockScroll, { passive: false });
    document.removeEventListener('wheel', blockScroll, { passive: false });
  }

  function close(method) {
    if (!root) return;
    var success = root.classList.contains('is-success');
    if (!success) ls(KEY_CLOSED, String(Date.now()));
    track('bb_popup_close', { method: method, after_signup: success });
    root.classList.remove('is-in');
    document.documentElement.classList.remove('bbpop-open');
    unlockScroll();
    document.removeEventListener('keydown', onKey);
    var r = root; root = null;
    setTimeout(function () { r.remove(); }, 260);
    try { lastFocus && lastFocus.focus && lastFocus.focus(); } catch (e) {}
  }

  function onKey(e) {
    if (!root) return;
    if (e.key === 'Escape') return close('esc');
    if (e.key === 'Tab') { // keep focus inside the dialog
      var f = [].slice.call(root.querySelectorAll('button, input, [tabindex]:not([tabindex="-1"])')).filter(function (el) { return el.offsetParent; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  /* ---------- submit → Klaviyo ---------- */
  function submit(e) {
    e.preventDefault();
    var form = e.currentTarget, input = form.querySelector('input'), btn = form.querySelector('button'), err = form.querySelector('.bbpop__err');
    var email = (input.value || '').trim();
    err.hidden = true;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      err.textContent = 'Please enter a valid email address.'; err.hidden = false; input.focus();
      track('bb_popup_error', { reason: 'invalid_email' });
      return;
    }
    btn.disabled = true; form.classList.add('is-busy');
    track('bb_popup_submit');

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source,
          profile: { data: { type: 'profile', attributes: {
            email: email,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.list } } }
      }
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.company), {
      method: 'POST',
      headers: { 'content-type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (r.status === 202 || r.ok) return success(email);
      return r.text().then(function (t) { throw new Error('klaviyo ' + r.status + ' ' + t.slice(0, 200)); });
    }).catch(function (ex) {
      btn.disabled = false; form.classList.remove('is-busy');
      err.textContent = 'Something went wrong — please try again.'; err.hidden = false;
      track('bb_popup_error', { reason: String(ex && ex.message || ex).slice(0, 90) });
    });
  }

  function success(email) {
    ls(KEY_DONE, String(Date.now())); ls(KEY_CLOSED, null);
    track('bb_popup_success');
    // Record the signup metric against the email that was just entered (Client Events API names the profile
    // explicitly, so it can't land on whoever this browser was previously cookied as).
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(cfg.company), {
        method: 'POST',
        headers: { 'content-type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: REVISION },
        body: JSON.stringify({ data: { type: 'event', attributes: {
          properties: { popup_id: 'bb_email_10off_v1', page: location.pathname },
          metric: { data: { type: 'metric', attributes: { name: 'BarBank Popup Signup' } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        } } })
      }).catch(function () {});
    } catch (e) {}
    // then re-cookie this browser as the new subscriber so the popup stays suppressed here
    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (e) {}
    if (!root) return;
    root.classList.add('is-success');
    root.querySelector('[data-bbpop-view="form"]').hidden = true;
    var s = root.querySelector('[data-bbpop-view="success"]'); s.hidden = false;
    var t = s.querySelector('[tabindex="-1"]'); t && t.focus();
  }

  /* ---------- triggers ---------- */
  // desktop exit intent: pointer leaves the viewport through the top edge
  document.addEventListener('mouseout', function (e) {
    if (e.relatedTarget || e.toElement) return;
    if (e.clientY > 8) return;
    attempt('exit_intent_desktop');
  });
  // mobile exit intent: a fast upward flick after the visitor has scrolled into the page
  var lastY = window.scrollY, lastT = Date.now(), maxY = 0;
  window.addEventListener('scroll', function () {
    var y = window.scrollY, t = Date.now();
    maxY = Math.max(maxY, y);
    var v = (lastY - y) / Math.max(1, t - lastT); // px per ms, positive = scrolling up
    if (maxY > 600 && v > 1.6 && window.matchMedia('(hover: none)').matches) attempt('exit_intent_mobile');
    lastY = y; lastT = t;
  }, { passive: true });

  // watch the age gate: when it closes, start the 3s grace window
  (function () {
    var h = document.documentElement;
    if (!(h.classList.contains('bb-age-active') || h.classList.contains('bb-age-exiting'))) return;
    var mo = new MutationObserver(function () {
      if (!h.classList.contains('bb-age-active') && !h.classList.contains('bb-age-exiting')) { ageClosedAt = Date.now(); mo.disconnect(); }
    });
    mo.observe(h, { attributes: true, attributeFilter: ['class'] });
  })();

  // mobile: phones have no exit-intent cursor, so also offer it on the visitor's 2nd page view this session
  (function () {
    if (!window.matchMedia('(hover: none)').matches) return;
    var n = 0;
    try { n = parseInt(sessionStorage.getItem('bb_pop_pv') || '0', 10) + 1; sessionStorage.setItem('bb_pop_pv', String(n)); } catch (e) { return; }
    if (n < 2) return;
    var go = function () { ageGateUp() ? setTimeout(go, 800) : attempt('second_page_mobile'); };
    setTimeout(go, 1500);
  })();

  if (force) {
    var go = function () { ageGateUp() ? setTimeout(go, 500) : attempt('forced_qa'); };
    setTimeout(go, 600);
  }
})();
